import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

interface AuthFormCardProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  primaryButtonText: string;
  primaryDisabled?: boolean;
  bottomText: string;
  bottomLinkText: string;
  bottomLinkTo: string;
  onPrimarySubmit?: (e: React.FormEvent) => void;
  /** Renders between submit button and bottom link (e.g. Google/GitHub) */
  afterSubmit?: ReactNode;
}

const AuthFormCard: React.FC<AuthFormCardProps> = ({
  title,
  subtitle,
  children,
  primaryButtonText,
  primaryDisabled,
  bottomText,
  bottomLinkText,
  bottomLinkTo,
  onPrimarySubmit,
  afterSubmit,
}) => {
  const logoUrl = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/logo.svg` : "/logo.svg";

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img src={logoUrl} alt="Logo" className="auth-logo" />
        <h1 className="auth-title">{title}</h1>
        <p className="auth-subtitle">{subtitle}</p>
        <form onSubmit={onPrimarySubmit || ((e) => e.preventDefault())}>
          {children}
          <button type="submit" className="auth-btn" disabled={primaryDisabled}>
            {primaryButtonText}
          </button>
        </form>
        {afterSubmit != null ? afterSubmit : null}
        <p className="auth-bottom">
          {bottomText}
          <Link to={bottomLinkTo} className="auth-link">
            {bottomLinkText}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default AuthFormCard;
